import axios from "axios";

export interface IProduct {
  id: number;
  name: string;
  price: number;
  image: string;
  unit?: string;
  oldPrice?: number;
  featured?: boolean;
}

function checkImageExists(image_url: string) {
  var http = new XMLHttpRequest();

  http.open("HEAD", image_url, false);
  http.send();

  return http.status === 200;
}

export const getProducts = async (): Promise<IProduct[]> => {
  const { data } = await axios.get("https://erba-supermarkt-server.herokuapp.com/v1/product");
  return data.products.slice(0, 100).map((product: IProduct) => {
    const imageUrl = `https://firebasestorage.googleapis.com/v0/b/erbasupermarkt.appspot.com/o/products%2F${product.image}?alt=media`;
    const imageExists = checkImageExists(imageUrl);
    return {
      ...product,
      image: imageExists || "/assets/placeholder-480x320.jpg",
    };
  });
};
